<template>
  <!-- <div class="warehouseToopTip" v-if="isClicked" @click="onClickChangeFilter()">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <span v-bind="attrs" v-on="on"> {{ StockTransferWarehouseQuery }}</span>
      </template>
      <span> {{ StockTransferWarehouseQuery }}</span>
    </v-tooltip>
  </div> -->

  <div>
    <v-autocomplete
      hide-details="auto"
      :items="warehouses"
      :loading="loading"
      v-model="selectedwarehouse"
      item-text="name"
      item-value="id"
      label="Warehouse"
      outlined
      clearable
      dense
      @change="emitInput"
      :search-input.sync="searchWarehouses"
    ></v-autocomplete>
  </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  props: {
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    warehouses: [],
    selectedwarehouse: null,
    searchWarehouses: null,
    loading: false,
    isClicked: true,
  }),
  computed: {
    ...mapState(['StockTransferWarehouse']),
    ...mapState(['StockTransferWarehouseQuery']),
  },
  methods: {
    emitInput(data) {
      this.$store.commit('UPDATE_STOCK_TRANFER_WAREHOUSE_FILTER', data);
      this.$emit('input', this.StockTransferWarehouse);
      this.$emit('changeFilter');
    },

    onClickChangeFilter() {
      this.isClicked = false;
    },
    getWarehouseByQuery(query = '') {
      this.loading = true;
      this.$store
        .dispatch('warehouse/GetWarehouse', {
          query: query,
          status: 'active',
        })
        .then((res) => {
          this.loading = false;
          this.warehouses = res;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
  watch: {
    clear: {
      handler(val) {
        this.selectedWarehouse = null;
      },
      deep: true,
    },
    searchWarehouses: {
      handler(val) {
        if (val !== 'Default') {
          this.$store.commit(
            'UPDATE_STOCK_TRANFER_WAREHOUSE_QUERY_FILTER',
            val,
          );
          this.getWarehouseByQuery(val);
        }
      },
      deep: true,
    },
  },
  created() {
    this.selectedwarehouse = this.StockTransferWarehouse;
    this.$emit('input', this.StockTransferWarehouse);

    this.getWarehouseByQuery();
  },
};
</script>

<style scoped>
.warehouseToopTip {
  display: flex;
  flex-direction: row;
  justify-content: center;
  font-weight: bold;
}
</style>
